import React from "react";
import { BiUpArrow, BiDownArrow } from "react-icons/bi";
const ProductInCart = ({
  name,
  image,
  desc,
  price,
  category,
  quantity,
  increaseQuantity,
  decreaseQuantity,
  content,
}) => {
  return (
    <div className="card rounded-md  lg:items-center shadow-base-200/50 bg-base-100 shadow-xl overflow-hidden lg:px-4 border border-gray-300 lg:px-8">
      <div className="lg:flex lg:flex-row lg:w-full">
        <div className="relative ">
          <figure className="h-56 transform scale-[1.35]  z-10 sm:scale-[1.1] lg:transform-none lg:w-56 ">
            <img className="lg:rounded-lg " src={image} alt={name} />
          </figure>
          <div className="badge rounded-md absolute right-3 top-3 text-lg p-4 sm:p-6 sm:top-6 sm:right-6 lg:hidden">
            ${price}
          </div>
        </div>

        <div className="card-body bg-base-100 z-20 md:flex md:items-center md:flex-row relative">
          <div className="md:flex-1">
            <h2 className="card-title">{name}</h2>
            <p>{desc}</p>
            <div className="badge badge-outline md:px-4 md:py-3 mt-1 md:mt-2">
              {category}
            </div>
            <div className="hidden badge rounded-md absolute right-3 top-3 text-lg p-4 sm:p-6 sm:top-6 sm:right-6 lg:hidden">
              ${price}
            </div>
          </div>
          <div className="card-actions justify-end flex items-center lg:flex-1">
            <div className="hidden lg:inline-block  flex items-center flex-1 place-items-center ml-3">
              <span className="badge badge-primary rounded-md text-lg p-6">
                ${price}
              </span>
            </div>
            <div className="flex gap-2 lg:flex-col lg:justify-center items-center lg:gap-2">
              <button
                onClick={() => increaseQuantity()}
                className="btn btn-primary mask mask-circle p-2 lg:p-3"
              >
                <BiUpArrow />
              </button>
              <span className="countdown lg:text-center">
                <span style={{ "--value": quantity }}></span>
              </span>

              <button
                className="btn btn-primary mask mask-circle p-2 lg:p-3"
                onClick={() => decreaseQuantity()}
              >
                <BiDownArrow />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="full-bleed-base w-full bg-base-300 text-primary card-body rounded-none py-2 lg:block flex flex-row">
        <span className="font-light">Content:</span>{" "}
        <span className="font-semibold">"{content}"</span>
      </div>
    </div>
  );
};

export default ProductInCart;
